import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withStyles, Grid } from './../../../themes/default';
import { PageService } from './../../../services';

import NotFoundComponent from './../component/_notfound';
import BannerImage from './../component/banner__image';
import TextHTML from './../component/text__html';
import TextPlain from './../component/text__plain';

const styles = theme => ({
  selection: {
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',
    borderRadius: theme.spacing.unit / 2,
    position: 'relative',
    border: `2px dashed ${ theme.palette.grey[300] }`,
    padding: theme.spacing.unit / 2
  },
  selection__mb: {
    marginBottom: theme.spacing.unit * 2
  },
  selection__name: {
    // display: 'flex',
    // position: 'absolute',
    // width: '100%',
    // top: 0,
    // left: 0,
    // zIndex: 9,
    // justifyContent: 'flex-end',
    // alignItems: 'center'
  },
  selection__nameCenter: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: theme.spacing.unit / 2
  }
});

class PageTemplate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false
    };
  }

  componentDidMount(){

    this._Components(this.props.page._id);

  }

  /*
  ** @Service
  ** @Description: Find components
  */

  _Components = (id) => {

    PageService.findComponentsByPageId(id).then((response) => {

      this.props.Update(response.components);

      this.setState({ loading: true  });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Submit
  ** @Description: Submit filter form
  */

  findAvalibleComponent = (identifier) => {

    let Result    = <NotFoundComponent/>;
    let Component = this.props.components.find( c => c.identifier === identifier );

    if(Component){

      if(Component.option.type === "banner__image"){
        Result = <BannerImage component={ Component }/>;
      }

      if(Component.option.type === "text__html"){
        Result = <TextHTML component={ Component }/>;
      }

      if(Component.option.type === "text__plain"){
        Result = <TextPlain component={ Component }/>;
      }

    }

    return Result;

  }

  render() {

    const { loading }       = this.state;
    const { page, classes } = this.props;

    return(

       loading &&  (

        <Grid container spacing={24}>
          {
            page.template.disposition.map((entity, index) => {
              return (
                <Grid item xs={ entity.column } key={ index }>
                  {
                    entity.siblings.map((sibling, index) => {
                        return (
                          <div
                            key={ sibling.identifier }
                            className={
                              classNames(
                                classes.selection,
                                (index+1) < entity.siblings.length ? classes.selection__mb : null
                              )
                          }>

                            <div className={ classes.selection__name }>

                              { this.findAvalibleComponent(sibling.identifier) }

                            </div>

                          </div>
                        )
                    })
                  }
                </Grid>
              )
              }
            )
          }
        </Grid>

      )

    )
  }

}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert,
    components: state.ComponentsUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'COMPONENT_UPDATE',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PageTemplate));
